export default __webpack_public_path__ + "5bc0d067bc777584c6dcadf305c2be79.gif";